<script lang="ts">
  import Border from "../../steps/Border.svelte";
  import StampType from "../../steps/StampType.svelte";
  import Spacing from "../../steps/Spacing.svelte";
  import type { ICanvas } from "src/ts/Interfaces";
  import type APIClient from "src/ts/APIClient";
  import ColourCombo from "./../../steps/ColourCombo.svelte";
  import TextLines from "../../steps/TextLines.svelte";
  import PlaceImages from "../../steps/PlaceImages.svelte";

  export let client: APIClient;
  export let canvas: ICanvas;

  let allowImageUpload: boolean = true;
</script>

<StampType hidden={canvas.hideStampType} bind:selected={canvas.stampType} />

<TextLines
  hidden={false}
  bind:lines={canvas.lines}
  bind:sections={canvas.sections}
/>

<PlaceImages
  hidden={!allowImageUpload}
  canvasWidth={canvas.canvasWidth}
  canvasHeight={canvas.canvasHeight}
  bind:images={canvas.images}
  {client}
/>

<ColourCombo
  colorComboType={canvas.colorComboType}
  hidden={canvas.colorComboType === 0}
  bind:selectedCombo={canvas.colorCombo}
/>

<Border hidden={canvas.hideBorder} bind:border={canvas.border} />

<Spacing hidden={canvas.hideSpacing} bind:spacing={canvas.spacing} />
